export const removeMask = (value: string) => value.replace(/\D/g, "");


export const removeMaskCpfCnpj = (value: string): string => {
  if (!value) return "";

  const onlyNumbers = value.replace(/\D/g, "");

  // CPF = 11 dígitos | CNPJ = 14 dígitos
  if (onlyNumbers.length === 11 || onlyNumbers.length === 14) {
    return onlyNumbers;
  }

  // Caso contrário, trata como nome
  return value
    .replace(/[^a-zA-ZÀ-ÿ\s]/g, "")
    .replace(/\s+/g, " ")
    .trim();
};